import * as THREE from 'three';
import { lightDefaults } from './lightDefaults';

export type MyScene = ReturnType<typeof makeScene>;

export interface CameraConfig {
  type: 'perspective' | 'orthographic';
  fov?: number;
}

export function makeScene(cameraConfig: CameraConfig) {
  const scene = new THREE.Scene();
  const hostGroup = new THREE.Group();
  const gridGroup = new THREE.Group();

  // --- КАМЕРА ---
  const camera =
    cameraConfig.type === 'perspective'
      ? new THREE.PerspectiveCamera(cameraConfig.fov || 75, 1, 1, 200000)
      : new THREE.OrthographicCamera(0, 0, 0, 0, 0, 0);

  // ВАЖНО: Добавляем камеру в сцену, чтобы источники света внутри неё работали корректно
  scene.add(camera);

  // grid
  gridGroup.add(
    new THREE.GridHelper(20000, 20, 0x660000, 0x444444),
    new THREE.GridHelper(2000, 20, 0x660000, 0x444444),
    new THREE.GridHelper(200, 20, 0x660000, 0x444444),
    new THREE.GridHelper(20, 20, 0x660000, 0x444444),
  );
  gridGroup.visible = false;

  // --- НАСТРОЙКИ СВЕТА ---

  // 1. Hemisphere Light (Глобальный) -> В СЦЕНУ
  // Он имитирует небо/землю, поэтому должен быть статичным
  const HemisphereLight = new THREE.HemisphereLight(
    new THREE.Color(...lightDefaults.hemisphere.skyColor),
    new THREE.Color(...lightDefaults.hemisphere.groundColor),
    lightDefaults.hemisphere.intensity,
  );
  scene.add(HemisphereLight);

  // 2. Main Light (Рисующий) -> В КАМЕРУ
  // Прикрепляем к камере, чтобы свет всегда светил "от зрителя"
  const DirectionalLight = new THREE.DirectionalLight(
    0xffffff,
    lightDefaults.directional.intensity,
  );
  DirectionalLight.position.set(...lightDefaults.directional.position);
  // Target по умолчанию (0,0,0). Так как свет внутри камеры,
  // он будет светить относительно взгляда, но фокусируясь на центре.

  // Тени
  DirectionalLight.castShadow = true;
  DirectionalLight.shadow.mapSize.width = 2048;
  DirectionalLight.shadow.mapSize.height = 2048;
  DirectionalLight.shadow.bias = -0.0001;

  // Добавляем к камере!
  camera.add(DirectionalLight);

  // 3. Back Light (Контровой) -> В КАМЕРУ
  // Он тоже двигается вместе с камерой, сохраняя красивый контур сзади
  const BackLight = new THREE.DirectionalLight(0xffffff, lightDefaults.back.intensity);
  BackLight.position.set(...lightDefaults.back.position);
  BackLight.castShadow = false;

  // Добавляем к камере!
  camera.add(BackLight);

  // 4. Ambient Light (Фоновый) -> В СЦЕНУ
  const AmbientLight = new THREE.AmbientLight(
    new THREE.Color(...lightDefaults.ambient.color),
    lightDefaults.ambient.intensity,
  );
  scene.add(AmbientLight);

  // Группы добавляем в сцену
  scene.add(gridGroup, hostGroup);

  return {
    scene,
    camera,
    groups: {
      hostGroup,
      gridGroup,
    },
    lights: {
      HemisphereLight,
      DirectionalLight,
      BackLight,
      AmbientLight,
    },
  };
}
